<fui-fields [formGroup]="editService.formGroup">
    <fui-field>
        <wbo-price-level-single-select-edit-control formControlName="priceLevelId"
                                                    [(ngModel)]="model.data.priceLevelId"></wbo-price-level-single-select-edit-control>
    </fui-field>
    <fui-field>
        <wbo-discount-single-select-edit-control formControlName="discountId"
                                                 [(ngModel)]="model.data.discountId"></wbo-discount-single-select-edit-control>
    </fui-field>

</fui-fields>
